/*
 * @Descripttion:
 * @version:
 * @Author: houhailong
 * @Date: 2023-05-21 16:05:15
 * @LastEditors: Aalon
 * @LastEditTime: 2023-05-21 16:15:04
 */
export enum HttpHeaderSettings {
  ContentType = 'Content-Type',
  Authorization = 'Authorization',
  applicationJson = 'application/json',
  applicationForm = 'multipart/form-data',
  BasicValue = 'Basic d2ViX2FwcDphbWVsby1zZWNyZXQ=',
}
